/* global Office */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./components/App/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

import "./index.css";

const Root = () => {
  return (
    <StrictMode>
      <FluentProvider
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
          height: "100%",
        }}
        theme={webLightTheme}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FluentProvider>
    </StrictMode>
  );
};

Office.onReady(() => {
  const container = document.getElementById("container");
  if (container === null) {
    throw new Error("container is null");
  }
  
  const root = createRoot(container);
  root.render(<Root />);
}).catch((err: unknown) => {
  console.error(err);
});
